import { render, staticRenderFns } from "./ConnectionsHistoryHead.vue?vue&type=template&id=f6dabd28&scoped=true"
import script from "./ConnectionsHistoryHead.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistoryHead.vue?vue&type=script&lang=js"
import style0 from "./ConnectionsHistoryHead.vue?vue&type=style&index=0&id=f6dabd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dabd28",
  null
  
)

export default component.exports